export default __webpack_public_path__ + "static/media/AwesomeAir_08.aec33ad4.png";